import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { billingGroupApi } from '../../api/lib/billing-group';
import { billingGroupsKeys } from '../../api/query-keys/billing-groups';

import { hostsKeys } from '@/features/hosts/api/query-keys/hosts';

export const useAttachHostToBillingGroup = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: ({ hostId, billingGroupId }: { hostId: number; billingGroupId: number }) =>
      billingGroupApi.addHostToBillingGroup(billingGroupId, hostId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: hostsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: billingGroupsKeys.all,
      });
      toast.success(t('common:popup.success'));

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
